import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e19a40b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "vue-notification-dialog-wrapper"
}
const _hoisted_2 = {
  class: "vue-notification-dialog",
  id: "vue-notification-dialog-identy"
}
const _hoisted_3 = { class: "vue-notification-dialog-title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "vue-notification-dialog-buttons"
}
const _hoisted_7 = ["onClick"]

import { ref } from "vue";
import { DialogModel } from "../models";
/**
 * Данные модального окна
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'dialog.plugin',
  emits: ["change"],
  setup(__props, { expose: __expose, emit }) {

const modalData = ref(new DialogModel());
/**
 * Состояние модального окна
 */
const visible = ref(false);
/**
 * Действия над модальным окном
 */
const clickButton = (value: boolean) => {
  emit("change", value);
  removeActiveClass();
};

/**
 * События
 */


/**
 * Открыть модальное окно
 */
const show = (data: DialogModel) => {
  modalData.value = new DialogModel(data);
  addActiveClass();
};

/**
 * Добавить клас для активации модального окна
 */
const addActiveClass = () => {
  visible.value = true;
  // emit("change", true);

  setTimeout(() => {
    let element = document.getElementById(
      "vue-notification-dialog-identy"
    ) as HTMLElement;

    if (
      element &&
      !element.classList.contains("vue-notofication-dialog-visible")
    )
      element.classList.add("vue-notofication-dialog-visible");
  }, 200);
};

/**
 * Удалить клас для активации модального окна
 */
const removeActiveClass = () => {
  let element = document.getElementById(
    "vue-notification-dialog-identy"
  ) as HTMLElement;

  if (element && element.classList.contains("vue-notofication-dialog-visible"))
    element.classList.remove("vue-notofication-dialog-visible");

  setTimeout(() => {
    visible.value = false;
  }, 200);
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "vue-notification-dialog-title-text",
              innerHTML: modalData.value.Title
            }, null, 8, _hoisted_4),
            _createElementVNode("i", {
              class: "mdi mdi-window-close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (clickButton(false)))
            })
          ]),
          _createElementVNode("div", {
            class: "vue-notification-dialog-content",
            innerHTML: modalData.value.Text
          }, null, 8, _hoisted_5),
          (modalData.value.Buttons)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modalData.value.Buttons, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(item.ButtonClass),
                    onClick: ($event: any) => (clickButton(item.Value))
                  }, _toDisplayString(item.Title), 11, _hoisted_7))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})